module.exports = __webpack_public_path__ + "img/gray-arrow.61636f79.png";